import { gql } from '@apollo/client'

export const INSURANCE_REPORT_QUERY = gql`
  query insuranceReport($filter: InsuranceReportFilter!) {
    insuranceReport(filter: $filter) {
      mainPeriod {
        benchmark
        completionRateEmployees
        completionRateFreelancers
        distributedToEmployees
        distributedToFreelancers
        feedbackRateEmployees
        feedbackRateFreelancers
        forwardedCasesFromTelrbTotal
        numberOfFeedbacks
        serviceCallCasesTotal
        transferredCasesInsurancesTotal
        transferredCasesTotal
      }
      comparisionPeriod {
        benchmark
        completionRateEmployees
        completionRateFreelancers
        distributedToEmployees
        distributedToFreelancers
        feedbackRateEmployees
        feedbackRateFreelancers
        forwardedCasesFromTelrbTotal
        numberOfFeedbacks
        serviceCallCasesTotal
        transferredCasesInsurancesTotal
        transferredCasesTotal
      }
      trend {
        benchmark
        completionRateEmployees
        completionRateFreelancers
        distributedToEmployees
        distributedToFreelancers
        feedbackRateEmployees
        feedbackRateFreelancers
        forwardedCasesFromTelrbTotal
        numberOfFeedbacks
        serviceCallCasesTotal
        transferredCasesInsurancesTotal
        transferredCasesTotal
      }
      team {
        title
        id
      }
      insurance {
        id
        title
      }
    }
  }
`
